import StatProgress from "components/elements/StatProgress";
import { LoansContext } from "providers/loans";
import { useContext, useEffect, useState } from "react";

const LoanTargetCount = ({ h }: { h?: string }) => {
  const { loans } = useContext(LoansContext);
  const [totalLoans, setTotalLoans] = useState<any>({
    stat: 0,
    target: 0,
  });

  useEffect(() => {
    const fundedLoans = loans.filter(
      (loan: any) => loan.status.isFunded,
    ).length;
    setTotalLoans({
      stat: fundedLoans,
      target: loans.length - fundedLoans,
    });
  }, [loans]);

  return (
    <StatProgress
      label="Total Loans"
      number={totalLoans.stat}
      value={
        (totalLoans.stat / (totalLoans.target + totalLoans.stat)) * 100 || 0
      }
      helpNumber={totalLoans.target}
      helpText="left to fund"
      helpColor="#FC2E53"
      h={h}
    />
  );
};

export default LoanTargetCount;
